export default [
    /* { 
        path: '/', 
        beforeEnter: (to, from, next) => {
            typeof store.state.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined"
                ? router.push('/admin_ordenes')
                : router.push('/ordenes')
        }
    }, */
    { 
        path: '/', 
        component: () => import('../components/public/web_page/home/IndexComponent')
    },
    { 
        path: '/nosotros', 
        component: () => import('../components/public/web_page/about_us/IndexComponent')
    },
    {
        path: '/medicamentos-especialidad/:search?', 
        component: () => import('../components/public/web_page/services/DrugCatalogsComponent'),
        children:[
            {
                path:'cotizacion',
                component:()=> import('../components/public/web_page/services/ProdcutsCheckoutComponent'),
                meta: { requiresAuth: true },
            },
            {
                path:'producto/:productId',
                component:()=> import('../components/public/web_page/services/InternalProductComponent')
            }
        ]
    },
    {
        path: '/aplicaciones',
        component:() => import('../components/public/web_page/services/AplicationsComponent')
    },
    {
        path: '/estudios-medicos',
        component:() => import('../components/public/web_page/services/MedicalStudiesComponent')
    },
    {
        path: '/enfermeria',
        component:() => import('../components/public/web_page/services/NursingComponent')
    },
    {
        path: '/empresas_pymes',
        component:() => import('../components/public/web_page/services/CompaniesAndPymesComponent'),
        children:[
            {
                path: 'cotizacion/:tipo?',
                component:() => import('../components/public/web_page/services/FormCotizacionComponent')
            }
        ]
    },
    { 
        path: '/sedes', 
        component: () => import('../components/public/web_page/head_quarters/IndexComponent'),
        children:[
            {
                path: 'servicio',
                component:() => import('../components/public/web_page/head_quarters/ServiceComponent')
            },
        ]
    },
    { 
        path: '/admin_ordenes', 
        component: () => import('../components/private/orders/AdminOrdersComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/ordenes',
        component: () => import('../components/public/orders/ListOrdersComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/carga_masiva',
        component: () => import('../components/private/orders/UploadOrdersMassiveComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/campana',
        component: () => import('../components/private/orders/PanelCampaignsComponent'),
        meta: { requiresAuth: true },
    },
    /* { 
        path: '/login', 
        component: () => import('../components/access/LoginComponent') ,
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            next();
        }
    }, */
    { 
        path: '/recuperar-contrasena/:token', 
        component: () => import('../components/access/ResetPasswordComponent') ,
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            next();
        }
    },
    { 
        path: '/reiniciar_contrasena/:token', 
        component: () => import('../components/access/ResetPasswordComponent') ,
        meta: { requiresAuth: false }
    },
    { 
        path: '/contactos', 
        component: () => import('../components/public/web_page/contacts/IndexComponent')
    },
    { 
        path: '/trabaja-con-nosotros', 
        component: () => import('../components/public/web_page/services/WorkWhitUsComponent')
    },
    { 
        path: '/covid19', 
        component: () => import('../components/public/web_page/services/Covid12Component')
    },
    { 
        path: '/preguntas-frecuentes-place-to-pay', 
        component: () => import('../components/public/web_page/services/FrequentlyAskedQuestionPlaceToPay')
    },
    { 
        path: '/terminos-y-condiciones', 
        component: () => import('../components/public/web_page/services/TermsAndConditions')
    },
    { 
        path: '/validar-usuario/:token', 
        component: () => import('../components/access/AuthUserComponent') ,
        meta: { requiresAuth: false }
    },
    { 
        path: '/covid19', 
        component: () => import('../components/public/web_page/services/Covid12Component')
    },
    { 
        path: '/perfil-cliente', 
        component: () => import('../components/public/web_page/services/CustomerComponent.vue'),
        children:[
            {
                path: 'transacciones',
                component:() => import('../components/public/web_page/services/CustomerTransactionsComponent.vue')
            },
            {
                path: 'tratamientos',
                component:() => import('../components/public/web_page/services/CustomerTeatmentsComponent.vue')
            },
            {
                path: 'datos-personales',
                component:() => import('../components/public/web_page/services/CustomerPersonalInformation.vue')
            }
        ],
        meta: { requiresAuth: true }
    },
    { 
        path: '/pago-placetopay/:reference', 
        component: () => import('../components/public/web_page/services/PlaceToPayPayment')
    },
    
  ]